export enum accuracyEnum {
    conceptual = 'conceptual',
    accurate = 'accurate',
    presentation = 'presentation',
}